import { notificationConstants } from "@constants";

const initalState = {
  create: {
    processing: false,
    fail: null
  }
};

export const notification = (state = initalState, action) => {
  switch (action.type) {
    case notificationConstants.CREATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        create: {
          processing: true
        }
      };
    case notificationConstants.CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        create: {
          processing: false
        }
      };
    case notificationConstants.CREATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        create: {
          processing: false,
          fail: action.error
        }
      };
    case notificationConstants.RESET_CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        create: initalState.create
      };
    default:
      return state;
  }
};
